import React, { useState } from 'react';
import InfoIcon from 'app/assets/svgIcons/InfoIcon';
import styles from './SlideOutPanel.module.scss';

interface InfoButtonProps {
  apiData?: any;
}

export const InfoButton: React.FC<InfoButtonProps> = ({ apiData }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Format the creation date
  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      const month = date.toLocaleString('en-US', { month: 'short' });
      const day = date.getDate();
      const year = date.getFullYear();
      const time = date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
      return `${month} ${day}, ${year} at ${time}`;
    } catch {
      return 'N/A';
    }
  };

  const creatorName = apiData?.creator || 'Unknown';
  const createdDate = formatDate(apiData?.created);

  return (
    <div
      className={styles.infoButtonContainer}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button className={styles.infoButton} aria-label="Information">
        <InfoIcon width={20} height={20} />
      </button>
      {isHovered && (
        <div className={styles.infoTooltip}>
          <div className={styles.infoTooltipItem}>
            <span className={styles.infoLabel}>Created By:</span>
            <span className={styles.infoValue}>{creatorName}</span>
          </div>
          <div className={styles.infoTooltipItem}>
            <span className={styles.infoLabel}>Created On:</span>
            <span className={styles.infoValue}>{createdDate}</span>
          </div>
        </div>
      )}
    </div>
  );
};
